// extracted by mini-css-extract-plugin
module.exports = {"circle":"Avatar_circle__3NddV","initials":"Avatar_initials__3zKDD","profilePicture":"Avatar_profilePicture__3_n0b"};